<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>JOBMIND(잡마인드)</h2>
        <p>
          배치 스케줄러 솔루션 JOBMIND를 이용한 체계적인 배치 업무 관리 및
          <br />
          배치 자동화 시스템 구축을 통해 고객 시스템 내의 안정적인 배치 업무
          운영을 지원합니다.
        </p>
      </div>
    </section>

    <main id="cont" class="product_sees">
      <div class="subCon seesCon inner_box">
        <div class="mainBox">
          <div class="benefit-1">
            <section id="benefit">
              <h3 class="con_tit" style="margin-bottom: 30px">
                JOBMIND(잡마인드) 소개
              </h3>
            </section>
          </div>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        <span class="text-danger">JOBMIND</span>
                        소개
                      </h1>
                      <p>
                        JOBMIND(잡마인드)는 순수국내 기술로 만든 배치 스케줄러 솔루션을 이용한
                        체계적인 배치 업무 관리 및 자동화 시스템 구축을 통해
                        가용성 확보 및 운영 효율성 극대화하며 고객 시스템 내의
                        안정적인 배치 업무 운영을 지원합니다.
                        <br /><br />배치통합 관리, 유연한 결재 시스템, 효율적
                        캘린더 관리, 안정적인 보안, 최적의 성능, Agent의 향상된
                        기능으로 체계화된 배치 작업 관리 시스템 구축 및 운영이
                        가능합니다.
                      </p>
                      <input type="hidden" value="배치스케줄러" />
                      <input type="hidden" value="잡스케줄러" />
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card height="100%">
                    <v-img
                      height="100%"
                      src="@/assets/img/product/sees/jobmindBenefit.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <div>
            <br /><br /><br /><br />
            <section id="features-title">
              <h3 class="con_tit" style="margin-bottom: 30px">
                JOBMIND(잡마인드) 특장점
              </h3>
            </section>
          </div>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    elevation="0"
                  >
                    <br />
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">배치 통합 관리</span>
                      </h1>
                      <p>
                        - 다양한 이기종 서버 및 분산 환경의 배치 작업을 하나의
                        스케줄러로 관리
                        <br /><br />- 다양한 배치 업무, 온라인 업무 및 프레임웍
                        연계를 통해 <b>배치 업무를 통합 관리</b><br /><br />-
                        API를 기반으로 작업의 등록, 수정, 삭제 및 활성 작업에
                        대한 액션 구현
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card>
                    <br />
                    <p class="con_subtit" style="font-size: 16px"></p>
                    <v-img
                      style="margin: 0 auto; width: 100%; align-items: center"
                      src="@/assets/img/product/sees/jobmindMain.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                    elevation="0"
                  >
                    <br />
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">유연한 결재 시스템</span>
                      </h1>
                      <p>
                        - 정기 및 수시 작업 등록, 캘린더 등록, ACTION수행,
                        소유자 변경의 결재 유형에 따른 <b>결재선 템플릿</b>을
                        생성 <br /><br />- 캘린더 변경에도 결재를 거쳐 등록,
                        수정, 삭제를 처리하여 캘린더 변경에 따른 리스크를 최소화
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card>
                    <br />
                    <p class="con_subtit" style="font-size: 16px"></p>
                    <v-img
                      style="margin: 0 auto; width: 100%; align-items: center"
                      src="@/assets/img/product/sees/jobmindApprovalLine_01.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">효율적 캘린더 관리</span>
                      </h1>
                      <p>
                        - 영업일, 휴일, 평일 등 사용자 등록 캘린더 와 익일/전일
                        처리, 말일 처리, 특정일 처리 등
                        <b>복잡한 스케줄</b>을 RULE 캘린더로 정의하여 관리
                        <br /><br />- 캘린더 변경에도 결재를 거쳐 등록, 수정,
                        삭제를 처리하여 캘린더 변경에 따른 리스크를 최소화
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card height="100%" class="text-center"
                    ><br />
                    <p class="con_subtit" style="font-size: 16px">
                      영업일 및 휴일 등 기본 캘린더를 생성하고 이를 이용한
                      복잡한 주기의 <br />Rule 캘린더를 생성하여 매년 새로
                      갱신하는 캘린더를 최소화합니다.
                    </p>
                    <v-img
                      width="100%"
                      src="@/assets/img/product/sees/jobmindCalender.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">에이전트 추가 기능</span>
                      </h1>
                      <p>
                        - 서버의 정보 (CPU, Memory)의 정보를 수집하여
                        <b>실시간 상태 모니터링</b> 및 시간대별 작업 분산 지표
                        제공 <br /><br />- <b>파일송수신 기능</b>을 통해 배치
                        작업과 관련된 파일전송 업무를 함께 관리
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card height="100%" class="text-center"
                    ><br />
                    <p class="con_subtit" style="font-size: 16px">
                      업무별 작업 수행 정보, 월간 작업 수행 현황, 수행 서버
                      상태, <br />서버별 수행 작업 통계 레포트를 제공 합니다.
                    </p>
                    <v-img
                      width="100%"
                      src="@/assets/img/product/sees/jobmindMonitoring.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">안정적인 보안</span>
                      </h1>
                      <p>
                        - 구간 암호화, 패스워드 암호화, WEB 취약점 점검을 통해
                        <b>안정성을 확보</b> <br /><br />- 사용자별 권한 및
                        역할을 분담하여 자신이 담당하고 있는 배치 작업만 관리
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        JOBMIND 특장점<br />
                        <span class="text-danger">최적의 성능</span>
                      </h1>
                      <p>
                        - 일자 변경 프로세스의 개선 및 병렬 처리로 배치 업무
                        수행에 공백이 없도록 함
                        <br /><br />
                        - 멀티 스레드 지원으로 대량 작업의 동시 수행 및 시스템
                        부하를 최소화
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <div>
            <br /><br /><br /><br />
            <section id="architecture-title">
              <h3 class="con_tit" style="margin-bottom: 30px">
                JOBMIND(잡마인드) 구성도
              </h3>
            </section>
          </div>

          <v-sheet
            elevation="1"
            class="mx-auto landing-warpper text-left"
            rounded
          >
            <v-sheet
              elevation="0"
              color="transparent"
              max-width="1600 "
              class="mx-auto my-10"
            >
              <v-row no-gutters align="stretch">
                <v-col cols="12" md="6">
                  <v-card
                    elevation="0"
                    height="100%"
                    class="mx-auto pa-10 pa-md-15 d-flex flex-column justify-center"
                  >
                    <div>
                      <RouterLink
                        to="/sees/seesjobmind"
                        class="text-primary font-weight-bold"
                        >JOBMIND</RouterLink
                      >
                      <h1 class="font-weight-black text-h4 mt-5 mb-10">
                        <span class="text-danger">JOBMIND</span>
                        구성도
                      </h1>
                      <p>
                        일괄작업 승인통제시스템은 사용자의 승인/결재 프로세스
                        기반으로 일괄작업을 관리하는 기능을 제공하며, 수행 대상
                        서버에 작업을 의뢰 및 수행하는 일괄작업 스케줄러 기능을
                        제공합니다.
                      </p>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card height="100%" class="text-center">
                    <v-img
                      width="100%"
                      src="@/assets/img/product/sees/jobmindArchitecture.png"
                    ></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-sheet>

          <!--  레퍼런스 -->
          <br /><br /><br /><br />
          <!--  레퍼런스 -->
          <div>
            <section id="reference-title">
              <h3 class="con_tit">자사 레퍼런스</h3>
            </section>
          </div>
          <SeesJobmindReferenceOncrew />
          <br /><br /><br /><br />
          <div>
            <section id="reference-title">
              <h3 class="con_tit">제조사 레퍼런스</h3>
            </section>
          </div>
          <seesJobmindReferenceSees />
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import seesJobmindReferenceSees from './seesJobmindReferenceSees.vue';
import SeesJobmindReferenceOncrew from './seesJobmindReferenceOncrew.vue';
export default {
  data: () => ({
    //
  }),
  components: {
    // SeesJobmindReference,
    seesJobmindReferenceSees,
    SeesJobmindReferenceOncrew,
  },
};
</script>
<style>
@import '@/assets/css/seesJobmind';
</style>
